import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('ShopPage').create(({ theme }) => ({
  root: {
    height: '100vh',
    width: '100vw',
    padding: '16px',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    paddingBottom: '96px',
  },
  tabsWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  selectCurrency: {
    fontWeight: '350',
    fontSize: theme.sizes.texts.fontSize.s,
    lineHeight: '100%',
    letterSpacing: '-1%',
    color: 'white',
  },

  headingWrapper: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center',
    gap: '4px',

    h1: {
      fontFamily: 'Inter',
      fontWeight: '500',
      fontSize: '34px',
      lineHeight: '40px',
      margin: '0',
      letterSpacing: '-2%',
      verticalAlign: 'middle',
      color: theme.colors.text.primary,
    },
    h2: {
      fontFamily: 'Inter',
      fontWeight: '350',
      fontSize: '14px',
      margin: '0',
      lineHeight: '20px',
      letterSpacing: '-1%',
      textAlign: 'center',
      color: theme.colors.text.secondary,
    },
  },

  tabList: {
    backgroundColor: '#2e2f34',
    position: 'sticky',
    opacity: '1',
    minHeight: '32px',
    width: 'fit-content',
    display: 'flex',
    flexDirection: 'row',
    borderRadius: '8px',
    '.MuiTabs-flexContainer': {
      justifyContent: 'space-between',
    },
    span: {
      display: 'none',
    },
  },

  tabPanel: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    padding: '0% 0%',

    '&[hidden]': {
      display: 'none',
    },
  },

  tab: {
    borderRadius: '7px',
    color: 'white',
    padding: '3px 10px',
    textTransform: 'none',
    minWidth: '0px',
    width: '60px',
    minHeight: '32px',
    fontFamily: 'Inter',
    fontWeight: '450',
    fontSize: 'clamp(12px, 2vw, 16px)',
    '&.Mui-selected': {
      backgroundColor: '#FFFFFF29',
      color: 'white',
      border: '0.5px solid rgba(0, 0, 0, 0.5)',
      boxShadow: '0px 3px 8px 0px rgba(0, 0, 0, 0.12), 0px 3px 1px 0px rgba(0, 0, 0, 0.04)',
    },
  },

  messageSupport: {
    textAlign: 'center',
    color: theme.colors.text.secondary,
    fontSize: '14px',
    lineHeight: '20px',
    fontWeight: '350',
    paddingBottom: '12px',
  },
}))
